import { ResponsiveBar } from '@nivo/bar';
import { getAreaShortName, dimColors } from '../constants';

const groups = ['Muy Bajo', 'Bajo', 'Neutro', 'Alto', 'Muy Alto'];

const getAreaData = ({ user, order }) => {

  const data = [
    {
      dimension: 'AC',
      value: parseFloat(user[`perc_AC_${order}_SUM`])
    },
    {
      dimension: 'AG',
      value: parseFloat(user[`perc_AG_${order}_SUM`])
    },
    {
      dimension: 'AR',
      value: parseFloat(user[`perc_AR_${order}_SUM`])
    },
    {
      dimension: 'CN',
      value: parseFloat(user[`perc_CN_${order}_SUM`])
    },
    {
      dimension: 'CS',
      value: parseFloat(user[`perc_CS_${order}_SUM`])
    },
    {
      dimension: 'D',
      value: parseFloat(user[`perc_D_${order}_SUM`])
    },
    {
      dimension: 'E',
      value: parseFloat(user[`perc_E_${order}_SUM`])
    },
    {
      dimension: 'H',
      value: parseFloat(user[`perc_H_${order}_SUM`])
    },
    {
      dimension: 'S',
      value: parseFloat(user[`perc_S_${order}_SUM`])
    },
    {
      dimension: 'T',
      value: parseFloat(user[`perc_T_${order}_SUM`])
    }
  ];

  const getValueGroup = val => {
    const value = parseFloat(val);
    if (value < 30) {
      return 'Muy Bajo';
    }
    if (value < 40) {
      return 'Bajo';
    }
    if (value < 60) {
      return 'Neutro';
    }
    if (value < 70) {
      return 'Alto';
    }
    return 'Muy Alto';
  };
  const groupColor = group => {
    switch (group) {
      case 'Muy Bajo':
        return dimColors[0];
      case 'Bajo':
        return dimColors[1];
      case 'Neutro':
        return dimColors[2];
      case 'Alto':
        return dimColors[3];
      case 'Muy Alto':
        return dimColors[4];
      default:
        return dimColors[0];
    }
  };

  const filteredData = data.filter(dp => {
    const isZero = dp.value === 0;
    const isFalsy = !dp.value;
    return !isFalsy || isZero;
  });

  const dataWithDetails = filteredData.map(el => {
    const group = getValueGroup(el.value);
    const color = groupColor(group);
    return { ...el, group, color };
  });

  const groupedData = dataWithDetails.map(dp => {
    const groupsvals = groups.reduce((acc, curr) => {
      let val = 0;
      if (curr === dp.group) {
        val = dp.value;
      }
      return { ...acc, [curr]: val };
    }, {});

    return {
      ...dp,
      dimension: dp.dimension,
      ...groupsvals
    };
  });
  return groupedData;
};

const MyResponsiveBar = ({ user, areas, order }) => {
  const areasData = getAreaData({ user, order });
  if (!areas) {
    return null;
  }
  const data = areasData.filter(area => areas.includes(area.dimension));
  return (
    <ResponsiveBar
      data={data}
      keys={groups}
      indexBy='dimension'
      layout='horizontal'
      // groupMode='grouped'
      isInteractive={false}
      margin={{ top: 20, right: 90, bottom: 40, left: 145 }}
      padding={0.3}
      maxValue={100}
      valueScale={{ type: 'linear' }}
      colors={dimColors}
      borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
      axisTop={null}
      axisRight={null}
      enableGridX
      enableGridY={false}
      axisLeft={{
        format: v => getAreaShortName(v)
      }}
      label={d => `${parseFloat(d.value).toFixed(0)}`}
      labelSkipWidth={12}
      labelSkipHeight={12}
      legends={[
        {
          anchor: 'right',
          direction: 'column',
          justify: false,
          translateX: 110,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: 'left-to-right',
          itemOpacity: 0.85,
          symbolSize: 20
        }
      ]}
      animate={false}
      motionStiffness={90}
      motionDamping={15}
    />
  );
};

export default MyResponsiveBar;
